import { ADJUSTMENT_GROUPS, AdjustmentControl, DEFAULT_ADJUSTMENTS, GAMMA_SCALE } from '../adjust.types'
import { AdjustGroupHeader, AdjustSlider, AdjustTextButton } from '../AdjustControlPrimitives.component'
import { FC, Fragment } from 'react'

import { Stack } from '@mui/material'
import { useAdjustEditor } from '../AdjustEditor.context'
import { useTranslation } from 'react-i18next'

const toSliderValue = (control: AdjustmentControl, value: number) => control.key === 'gamma' ? Math.round(value * GAMMA_SCALE) : value
const fromSliderValue = (control: AdjustmentControl, value: number) => control.key === 'gamma' ? value / GAMMA_SCALE : value
const formatValue = (control: AdjustmentControl, value: number) => control.key === 'gamma' ? (value / GAMMA_SCALE).toFixed(2) : String(Math.round(value))

/** Light, Color and Detail sliders (Pintura's 8 + highlights, shadows and tint) */
export const FineTuneControls: FC<{ disabled?: boolean }> = ({ disabled = false }) => {
  const { t } = useTranslation(['photo_studio_editing'])
  const { doc, apply, commit } = useAdjustEditor()
  const isChanged = (Object.keys(DEFAULT_ADJUSTMENTS) as Array<keyof typeof DEFAULT_ADJUSTMENTS>).some(key => doc.adjustments[key] !== DEFAULT_ADJUSTMENTS[key])

  return (
    <Stack gap="1rem">
      {ADJUSTMENT_GROUPS.map((group, index) => (
        <Fragment key={group.id}>

          <AdjustGroupHeader
            title={t(`adjust.finetune.group.${group.id}`)}
            action={index === 0 ? <AdjustTextButton label={t('adjust.reset_all')} disabled={disabled || !isChanged} onClick={() => apply({ type: 'resetAdjustments' })} /> : undefined}
          />

          {group.controls.map((control) => {
            const value = toSliderValue(control, doc.adjustments[control.key])
            const origin = toSliderValue(control, DEFAULT_ADJUSTMENTS[control.key])
            return (
              <AdjustSlider
                key={control.key}
                label={t(`adjust.finetune.${control.key}`)}
                value={value}
                valueLabel={formatValue(control, value)}
                min={control.min}
                max={control.max}
                origin={origin}
                isNew={control.isNew}
                disabled={disabled}
                onChange={(next) => apply({ type: 'setAdjustment', key: control.key, value: fromSliderValue(control, next) }, `adjustment:${control.key}`)}
                onCommit={commit}
                onReset={() => apply({ type: 'resetAdjustment', key: control.key })}
              />
            )
          })}

        </Fragment>
      ))}
    </Stack>
  )
}
